import PropTypes from 'prop-types';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Info, Forum, CollectionsBookmark, Work, } from '@mui/icons-material';
import MailIcon from '@mui/icons-material/Mail';
import me from '../me.png';
import Avatar from '@mui/material/Avatar';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme, } from '@mui/material';
import ColorModeContext from '../contexts/ColorMode';
import React from 'react';
import { Link, } from 'react-router-dom';

const MainNavigationItems = [
  { label: 'About', url: "about", Icon: Info, }, //TODO: add icon here
  { label: 'Blog', url: "blog", Icon: Forum, }, //TODO: add icon here
  { label: 'Projects', url: "projects", Icon: CollectionsBookmark, }, //TODO: add icon here
  { label: 'Hire Me', url: "contact", Icon: Work, } //TODO: add icon here
]

const drawerWidth = 240;

function ResponsiveDrawer(props) {
  const colorMode = React.useContext(ColorModeContext);
  const theme = useTheme();
  const { window, handleDrawerToggle, open, } = props;

  const container = window !== undefined ? () => window().document.body : undefined;

  const drawer = (
    <div style={{ height: '100%' }}>
      <div className="stars">
        <div className="twinkling">
          <div style={{ display: 'flex', justifyContent: 'center', }} >
            <div style={{ backgroundColor: theme.palette.background.paper, borderRadius: '50%', padding: 4, margin: 8, }}>
              <Avatar src={me} alt="Bryan Maldonado" sx={{ width: 130, height: 130, }} />
            </div>
          </div>
        </div>
      </div>
      <Divider />
      <List onClick={handleDrawerToggle}>
        {MainNavigationItems.map(({ label, url, Icon }) => (
          <ListItem component={Link} to={url} button key={url}>
            <ListItemIcon>
              <Icon />
            </ListItemIcon>
            <ListItemText primary={label} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {['Resume', 'Instagram', 'Youtube'].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>

      <List sx={{ position: 'absolute', bottom: 0, display: { xs: 'block', md: 'none' } }}>
        <ListItem button onClick={colorMode.toggleColorMode}>
          <ListItemIcon>
            {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
          </ListItemIcon>
          <ListItemText primary={theme.palette.mode === 'dark' ? "Light Theme" : "Dark theme"} />
        </ListItem>
      </List>
    </div>
  );

  return (
    <>
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        container={container}
        variant="temporary"
        open={open}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { md: 'block', lg: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        {drawer}
      </Drawer>

      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', lg: 'block' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
        open
      >
        {drawer}
      </Drawer>
    </>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
  handleDrawerToggle: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ResponsiveDrawer;
